import { useMutation } from '@tanstack/react-query';
import { ApiTypes } from 'common';
import { ApiError } from '@src/services/api';
import { describeMedia } from './api';

export const useMutationMediaDescribe = () =>
  useMutation<
    ApiTypes.ResPostMediaDescribe,
    ApiError,
    ApiTypes.ParamsPostMediaDescribe
  >({
    mutationFn: (params) => describeMedia(params),
  });
